(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["divinch-related-products"]) return;
  try {
    
(() => {
  const shuffle = (items) => {
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  const initialize = async (section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const grid = section.querySelector('.product-related-grid');
    const count = Number(section.dataset.complementaryCount);
    const fixed = [...grid.children].slice(0, count);
    const needed = 4 - fixed.length;
    const local = [...section.querySelectorAll('template[data-moao-candidate]')];
    const pool = new Map();
    const pages = shuffle(Array.from({length: Number(section.dataset.pages)}, (_, i) => i + 1));
    for (const page of pages) {
      let candidates = local;
      if (page !== Number(section.dataset.currentPage)) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', section.dataset.sectionId);
          url.searchParams.set(section.dataset.pageParam, String(page));
          const response = await fetch(url, {signal: AbortSignal.timeout(6000)});
          if (!response.ok) continue;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          candidates = [...html.querySelectorAll('template[data-moao-candidate]')];
        } catch (error) {
          break;
        }
      }
      for (const item of shuffle(candidates)) pool.set(item.dataset.moaoCandidate, item);
      if (pool.size >= needed) break;
    }
    for (const item of shuffle(local)) {
      if (pool.size >= needed) break;
      pool.set(item.dataset.moaoCandidate, item);
    }
    const extra = shuffle([...pool.values()]).slice(0, needed).map((item) => item.content.firstElementChild.cloneNode(true));
    grid.replaceChildren(...fixed, ...extra);
    section.dataset.randomCount = String(extra.length);
    section.hidden = grid.children.length === 0;
  };
  document.querySelectorAll('[data-moao-pairs]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-moao-pairs]').forEach(initialize);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moao-header"]) return;
  try {
    
function initializeMoaoNavigation() {
  document.querySelectorAll('.moao-header').forEach(function(header) {
    if (header.dataset.navigationReady) return;
    header.dataset.navigationReady = 'true';

    const mobileMenu = header.querySelector('.moao-mobile-menu');
    const mobileToggle = mobileMenu.querySelector(':scope > summary');
    function updateMobileNavigation() {
      header.style.setProperty('--moao-mobile-menu-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
      mobileToggle.setAttribute('aria-label', mobileMenu.open ? 'Close menu' : 'Open menu');
      mobileToggle.setAttribute('aria-expanded', String(mobileMenu.open));
    }
    mobileMenu.addEventListener('toggle', updateMobileNavigation);
    window.addEventListener('resize', function() {
      if (window.matchMedia('(min-width:1181px)').matches) mobileMenu.open = false;
      updateMobileNavigation();
    });
    header.addEventListener('keydown', function(event) {
      if (event.key !== 'Tab' || !mobileMenu.open) return;
      const focusable = [...header.querySelectorAll('a[href],summary,input,button')].filter(function(el) { return el.getClientRects().length && !el.disabled; });
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    mobileMenu.querySelectorAll('a').forEach(function(link) { link.addEventListener('click', function() { mobileMenu.open = false; }); });
    updateMobileNavigation();
    const menus = header.querySelectorAll('.moao-nav-submenu,.moao-mobile-menu,.moao-mobile-section,.moao-search');
    function closeOthers(current) {
      menus.forEach(function(menu) {
        if (menu !== current && !menu.contains(current) && !current.contains(menu)) menu.open = false;
      });
    }
    menus.forEach(function(menu) {
      menu.querySelector('summary').addEventListener('click', function() {
        if (!menu.open) closeOthers(menu);
      });
    });
    header.querySelectorAll('.moao-desktop-nav .moao-nav-group').forEach(function(group) {
      const menu = group.querySelector('details');
      if (!menu) return;
      let timer;
      group.addEventListener('pointerenter', function(event) {
        if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width:1181px)').matches) return;
        clearTimeout(timer);
        timer = setTimeout(function() { closeOthers(menu); menu.open = true; }, 140);
      });
      group.addEventListener('pointerleave', function() {
        clearTimeout(timer);
        timer = setTimeout(function() { if (!group.contains(document.activeElement)) menu.open = false; }, 220);
      });
      group.addEventListener('focusout', function(event) {
        if (!group.contains(event.relatedTarget)) menu.open = false;
      });
    });
    document.addEventListener('pointerdown', function(event) {
      if (header.contains(event.target)) return;
      menus.forEach(function(menu) { if (!menu.contains(event.target)) menu.open = false; });
    }, true);
    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;
      menus.forEach(function(menu) {
        if (!menu.open) return;
        if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
        menu.open = false;
      });
    });
  });
}
initializeMoaoNavigation();
document.addEventListener('shopify:section:load', initializeMoaoNavigation);
(() => {
  const drawer = document.querySelector('[data-moao-cart-drawer]');
  if (!drawer || drawer.dataset.initialized || typeof drawer.showModal !== 'function') return;
  drawer.dataset.initialized = 'true';
  const desktop = window.matchMedia('(min-width: 761px)');
  const root = drawer.dataset.rootUrl;
  const sectionId = drawer.dataset.sectionId;
  const status = drawer.querySelector('[data-moao-cart-status]');
  const errorBox = drawer.querySelector('[data-moao-cart-error]');
  let busy = false;
  let returnFocus = null;
  let previousOverflow = '';
  const showError = (message) => {
    errorBox.textContent = message;
    errorBox.hidden = !message;
    if (message) {
      const recovery = document.createElement('a');
      recovery.href = drawer.dataset.cartUrl;
      recovery.textContent = 'View full bag';
      errorBox.append(' ', recovery);
    }
  };
  const setBusy = (value) => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    document.querySelectorAll('[data-moao-quantity], [data-moao-drawer-checkout] button, [data-moao-discount] button, #cart-page-form button, #cart-page-form .cart-quantity-input').forEach(button => { button.disabled = value; });
    document.querySelectorAll('[data-moao-discount-input]').forEach(input => { input.readOnly = value; });
  };
  const show = (trigger) => {
    if (!desktop.matches || drawer.open) return;
    returnFocus = trigger || document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    drawer.showModal();
    drawer.querySelector('[data-moao-cart-close]').focus({ preventScroll: true });
  };
  const close = () => { if (drawer.open) drawer.close(); };
  drawer.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  });
  drawer.addEventListener('click', (event) => {
    if (event.target.closest('[data-moao-cart-close]')) close();
    if (event.target === drawer) {
      const bounds = drawer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    }
  });
  desktop.addEventListener('change', () => { if (!desktop.matches) close(); });
  const render = (html) => {
    if (typeof html !== 'string') return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = parsed.querySelector('[data-moao-cart-view]');
    if (!incoming) return false;
    const view = drawer.querySelector('[data-moao-cart-view]');
    view.replaceWith(incoming);
    const count = incoming.dataset.itemCount;
    drawer.querySelector('[data-moao-drawer-count]').textContent = `(${count})`;
    document.querySelectorAll('.moao-bag-count').forEach(node => { node.textContent = `(${count})`; });
    document.querySelectorAll('.moao-bag-link').forEach(node => { node.setAttribute('aria-label', `Bag ${count} items`); });
    syncDiscountControls();
    setBusy(busy);
    return true;
  };
  const refresh = async () => {
    const response = await fetch(`${root}?sections=${encodeURIComponent(sectionId)}`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Your bag could not be loaded. Please use View full bag to check it.');
    const data = await response.json();
    if (!render(data[sectionId])) throw new Error('Your bag could not be loaded. Please use View full bag to check it.');
  };
  const load = async (trigger) => {
    if (busy) return;
    show(trigger);
    showError('');
    setBusy(true);
    status.textContent = 'Loading your bag…';
    try { await refresh(); captureDiscounts(await readCartDiscounts().catch(() => null)); status.textContent = ''; }
    catch (error) { status.textContent = ''; showError(error.message); }
    finally { setBusy(false); }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.moao-bag-link');
    if (!link || !desktop.matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    load(link);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!desktop.matches || !form.matches('[data-product-form]')) return;
    if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
    const variant = form.querySelector('[name="id"]');
    const sizes = form.querySelectorAll('input[name="product-size"]');
    if (!variant?.value || (sizes.length && !form.querySelector('input[name="product-size"]:checked'))) return;
    if (!form.checkValidity()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const button = form.querySelector('[data-add-to-cart]');
    const label = button?.querySelector('[data-add-to-cart-label]');
    const oldLabel = label?.textContent;
    const message = form.querySelector('[data-selection-message]');
    const data = new FormData(form);
    data.set('sections', sectionId);
    data.set('sections_url', root);
    setBusy(true);
    showError('');
    if (message) message.textContent = '';
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if (label) label.textContent = 'ADDING…';
    let added = false;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok) {
        const detail = typeof result.description === 'string' ? result.description : 'This item could not be added. Please check availability.';
        throw new Error(detail);
      }
      added = true;
      captureDiscounts(await readCartDiscounts().catch(() => null));
      if (!render(result.sections?.[sectionId])) await refresh();
      status.textContent = 'Added to your bag.';
      show(button);
    } catch (error) {
      const messageText = added ? 'Your item was added, but the bag could not refresh. Please view your full bag before adding it again.' : (error instanceof TypeError ? 'We could not confirm the addition. Please check your bag before trying again.' : error.message);
      if (message) message.textContent = messageText;
      if (added) { show(button); showError(messageText); }
    } finally {
      setBusy(false);
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      if (label) label.textContent = oldLabel;
    }
  }, true);
  drawer.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-moao-quantity]');
    if (!button || busy) return;
    const line = button.closest('[data-moao-cart-key]');
    const key = line.dataset.moaoCartKey;
    const quantity = Number(button.dataset.moaoQuantity);
    const itemIndex = [...drawer.querySelectorAll('[data-moao-cart-key]')].indexOf(line);
    showError('');
    status.textContent = 'Updating your bag…';
    setBusy(true);
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: [sectionId], sections_url: root })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This quantity is unavailable. Please try a smaller quantity.');
      captureDiscounts(result);
      if (!render(result.sections?.[sectionId])) await refresh();
      status.textContent = quantity === 0 ? 'Item removed.' : 'Bag updated.';
      setBusy(false);
      const items = drawer.querySelectorAll('[data-moao-cart-key]');
      const target = items[Math.min(itemIndex, items.length - 1)];
      (target?.querySelector('[data-moao-quantity]') || drawer.querySelector('[data-moao-cart-close]')).focus({ preventScroll: true });
    } catch (error) {
      status.textContent = '';
      try { await refresh(); } catch (_) { }
      showError(error instanceof TypeError ? 'We could not confirm the update. Please check your full bag before trying again.' : error.message);
    } finally { setBusy(false); }
  });
  // Shopify stores discounts on the cart, so both Xcotton checkout paths retain them.
  let discountCodes = [];
  const syncDiscountControls = () => {
    document.querySelectorAll('[data-moao-discount-codes]').forEach(list => {
      list.replaceChildren();
      discountCodes.forEach(code => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'moao-discount__code';
        button.dataset.moaoDiscountRemove = code;
        button.setAttribute('aria-label', `Remove discount ${code}`);
        button.textContent = `${code} ×`;
        button.disabled = busy;
        list.append(button);
      });
    });
  };
  const captureDiscounts = (cart) => {
    if (!Array.isArray(cart?.discount_codes)) return;
    discountCodes = cart.discount_codes.filter(item => item.applicable).map(item => item.code);
    syncDiscountControls();
  };
  const discountMessage = (context, message, isError = false) => {
    const control = document.querySelector(`[data-moao-discount="${context}"]`);
    const output = control?.querySelector('[data-moao-discount-message]');
    if (output) { output.textContent = message; output.dataset.error = String(isError); }
    control?.querySelector('[data-moao-discount-input]')?.setAttribute('aria-invalid', String(isError));
  };
  const readCartDiscounts = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to check your current discount codes. Please try again.');
    return response.json();
  };
  const updateDiscount = async (control, removeCode) => {
    if (busy) return;
    const context = control.dataset.moaoDiscount;
    const input = control.querySelector('[data-moao-discount-input]');
    const code = removeCode || input.value.trim();
    if (!code || code.includes(',')) {
      discountMessage(context, 'Enter one discount code at a time.', true);
      input.focus();
      return;
    }
    setBusy(true);
    discountMessage(context, removeCode ? 'Removing code…' : 'Applying code…');
    try {
      const current = await readCartDiscounts();
      const existing = (current.discount_codes || []).filter(item => item.applicable).map(item => item.code);
      const codes = existing.filter(item => item.toLowerCase() !== code.toLowerCase());
      if (!removeCode) codes.push(code);
      const fullCart = document.querySelector('[data-moao-full-cart]');
      const sections = [sectionId];
      if (fullCart) sections.push(fullCart.dataset.sectionId);
      const response = await fetch(`${root}cart/update.js`, {
        method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections, sections_url: window.location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(typeof cart.description === 'string' ? cart.description : 'The discount could not be updated. Please try again.');
      captureDiscounts(cart);
      let html = cart.sections;
      if (!html?.[sectionId] || (fullCart && !html[fullCart.dataset.sectionId])) {
        const sectionResponse = await fetch(`${root}?sections=${encodeURIComponent(sections.join(','))}`, { cache: 'no-store' });
        if (!sectionResponse.ok) throw new Error('Your code was submitted, but totals could not refresh. Reload your bag to check it.');
        html = await sectionResponse.json();
      }
      if (!render(html[sectionId])) throw new Error('Your code was submitted, but totals could not refresh. Reload your bag to check it.');
      if (fullCart) {
        const parsed = new DOMParser().parseFromString(html[fullCart.dataset.sectionId] || '', 'text/html');
        const incoming = parsed.querySelector('[data-moao-full-cart]');
        if (!incoming) throw new Error('Your code was submitted, but totals could not refresh. Reload your bag to check it.');
        fullCart.replaceWith(incoming);
      }
      syncDiscountControls();
      const applicable = cart.discount_codes?.some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
      discountMessage(context, removeCode ? 'Discount code removed.' : applicable ? '' : 'This code is invalid or does not apply to your bag.', !removeCode && !applicable);
      const newInput = document.querySelector(`[data-moao-discount="${context}"] [data-moao-discount-input]`);
      if (newInput) {
        if (!removeCode && !applicable) newInput.value = code;
        newInput.focus({ preventScroll: true });
      }
    } catch (error) {
      discountMessage(context, error instanceof TypeError ? 'We could not confirm the update. Reload your bag before trying again.' : error.message, true);
    } finally { setBusy(false); }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-moao-discount-apply], [data-moao-discount-remove]');
    if (!button) return;
    event.preventDefault();
    updateDiscount(button.closest('[data-moao-discount]'), button.dataset.moaoDiscountRemove);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-moao-discount-input]')) {
      event.preventDefault();
      updateDiscount(event.target.closest('[data-moao-discount]'));
    }
    const action = event.target.closest('a[data-xmh-checkout-without][role="button"]');
    if (action && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      if (!busy) action.click();
    }
  });
  // Xcotton creates these controls after every cart refresh. Preserve its delegated handlers.
  const prepareProtectionButtons = () => {
    document.querySelectorAll(':is(.moao-cart-drawer, .cart-page-summary) a[data-xmh-checkout-without]').forEach(button => {
      if (button.getAttribute('role') !== 'button') button.setAttribute('role', 'button');
      if (button.getAttribute('tabindex') !== '0') button.setAttribute('tabindex', '0');
    });
  };
  prepareProtectionButtons();
  new MutationObserver(prepareProtectionButtons).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', event => {
    if (busy && event.target.closest('[data-xmh-checkout], [data-xmh-checkout-without], [name="checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  readCartDiscounts().then(cart => { if (!busy) captureDiscounts(cart); }).catch(() => {});

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moao-home"]) return;
  try {
    
function initMoaoStories(scope) {
  scope.querySelectorAll('[data-moao-stories]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('.moao-stories__track');
    const slides = [...track.querySelectorAll('.moao-story')];
    const pages = [...root.querySelectorAll('[data-story-index]')];
    const status = root.querySelector('.moao-stories__status');
    const controls = root.querySelector('.moao-stories__controls');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let scrollTimer;
    let autoTimer;
    let hovering = false;
    let manuallyPaused = false;
    let announceNext = false;
    const update = () => {
      const next = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      pages.forEach((button, index) => {
        if (index === next) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      slides.forEach((slide, index) => { slide.inert = index !== next; });
      if (next !== current && announceNext) status.textContent = slides[next].getAttribute('aria-label');
      current = next;
      announceNext = false;
    };
    const go = (index, manual = false) => {
      if (manual) {
        manuallyPaused = true;
        announceNext = true;
      }
      const target = (index + slides.length) % slides.length;
      slides.forEach(slide => { slide.inert = false; });
      track.scrollTo({ left: target * track.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    if (slides.length > 1) {
      if (controls) controls.hidden = false;
      root.addEventListener('click', event => {
        const step = event.target.closest('[data-story-step]');
        const page = event.target.closest('[data-story-index]');
        if (step) go(current + Number(step.dataset.storyStep), true);
        else if (page) go(Number(page.dataset.storyIndex), true);
        else manuallyPaused = true;
      });
      root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovering = true; });
      root.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') hovering = false; });
      root.addEventListener('keydown', () => { manuallyPaused = true; });
      track.addEventListener('pointerdown', () => { manuallyPaused = true; announceNext = true; }, { passive: true });
      track.addEventListener('wheel', () => { manuallyPaused = true; announceNext = true; }, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          go(current + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      });
      autoTimer = window.setInterval(() => {
        if (!root.isConnected) { window.clearInterval(autoTimer); return; }
        if (manuallyPaused || hovering || root.contains(document.activeElement) || document.hidden || reducedMotion.matches) return;
        go(current + 1);
      }, 7000);
    }
    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(update, 120);
    }, { passive: true });
    track.addEventListener('scrollend', update);
    if ('ResizeObserver' in window) new ResizeObserver(() => {
      track.scrollTo({ left: current * track.clientWidth, behavior: 'instant' });
    }).observe(track);
    update();
  });
}
initMoaoStories(document);
document.addEventListener('shopify:section:load', event => initMoaoStories(event.target));

  } catch(e) { console.error(e); }
})();
})();
